import styled from 'styled-components';

export const SubtleButton = styled.button`
  border: 0;
  background-color: unset;
  padding: 0;
  font-family: inherit;
  text-decoration: underline;
  color: ${(p) => p.theme.kallisto.color.text.static.textPrimary};
  cursor: pointer;
`;

// Underlined primary-coloured "See all …" text link (Body). Shared so the facilities and
// location sections render an identical link.
export const SeeAllButton = styled(SubtleButton)`
  ${({ theme }) => theme.kallisto.mixins.font('Body')};
  color: ${(p) => p.theme.kallisto.color.text.interactive.textPrimaryDefault};
  padding: 0;
  text-decoration: underline;
  text-align: left;
`;
